import { Injectable } from '@angular/core'; import { ReplaySubject } from 'rxjs';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map, shareReplay, switchMap } from 'rxjs/operators';
import { InstagramGalleryService } from './instagram-gallery.service';
@Injectable({
  providedIn: 'root'
})
export class AccountSelectorService {

  private accountsCache$: Observable<any[]> | null = null;

  constructor(private gallery: InstagramGalleryService) { }

  private instagramAccounts$?: ReplaySubject<any[]>;

  getInstagramAccounts(): Observable<any[]> {
    if (this.instagramAccounts$) {
      return this.instagramAccounts$.asObservable();
    }
  
    this.instagramAccounts$ = new ReplaySubject<any[]>(1);
  
    this.gallery.getFacebookAccounts().pipe(
      catchError(() => of({ accounts: [] })),
      switchMap(response => {
        const facebookAccounts = response.accounts || [];
  
        if (facebookAccounts.length === 0) {
          return of([]);
        }
  
        const allPages$ = facebookAccounts.map(acc =>
          this.gallery.listFacebookPages(10, undefined, acc.id).pipe(
            catchError(() => of({ data: [] })),
            map(res => (res?.data ?? []).map((page: any) => ({ page, fbId: acc.id })))
          )
        );
  
        return forkJoin(allPages$).pipe(
          map(pages => pages.flat()),
          switchMap(flatPages => {
            if (flatPages.length === 0) {
              return of([]);
            }
  
            const igCalls = flatPages.map(({ page, fbId }) =>
              this.gallery.getInstagramAccountForPage(page.id, fbId).pipe(
                map(acc => acc ? { ...acc, fbId, page_id: page.id } : null),
                catchError(() => of(null))
              )
            );
  
            return forkJoin(igCalls);
          }),
          map(results => results.filter(acc => acc !== null && acc?.id))
        );
      })
    ).subscribe((accounts) => {
      this.instagramAccounts$!.next(accounts); // preenche o ReplaySubject
    });
  
    return this.instagramAccounts$.asObservable();
  }
  
  
  // getInstagramAccounts(): Observable<any[]> {
  //   return this.gallery.getFacebookAccounts().pipe(
  //     catchError(() => of({ accounts: [] })), // ⬅️ TRATA o erro 404 aqui
  //     switchMap(response => {
  //       const facebookAccounts = response.accounts || [];
  
  //       if (facebookAccounts.length === 0) {
  //         return of([]);
  //       }
  
  //       const allPages$ = facebookAccounts.map(acc =>
  //         this.gallery.listFacebookPages(10, undefined, acc.id).pipe(
  //           catchError(() => of({ data: [] })),
  //           map(res => res.data.map((page: any) => ({ page, fbId: acc.id })))
  //         )
  //       );
  
  //       return forkJoin(allPages$).pipe(
  //         map(pages => pages.flat()),
  //         switchMap(flatPages => {
  //           if (flatPages.length === 0) {
  //             return of([]);
  //           }
  
  //           const igCalls = flatPages.map(({ page, fbId }) =>
  //             this.gallery.getInstagramAccountForPage(page.id, fbId).pipe(
  //               map(acc => acc ? { ...acc, fbId, page_id: page.id } : null),
  //               catchError(() => of(null))
  //             )
  //           );
  
  //           return forkJoin(igCalls);
  //         }),
  //         map(results => results.filter(acc => acc !== null && acc?.id))
  //       );
  //     })
  //   );
  // }
}
